<template>
    <div id="mobile-trajectory">
        <v-ws v-on:onopen="initSearch" :sendMessage="sendMessage" v-on:vehicle_search="changeSearchData" ></v-ws>
        <el-popover
          ref="popover"
          placement="right"
          width="540"
          trigger="click"
          v-model="visible"
          >
            <div class="pover-search">
                <v-search v-on:select="searchSelectCurrent" v-on:search="createVehicleSearch" :serchData="serchData" :showConfirmBt='true' v-on:cancelSelect="cancelSelect">
                </v-search>
            </div>
        </el-popover>
        <div class="container">
            <el-row :gutter="15">
                <el-col :span="7" >
                    <div class="container-panel">
                        <p class="title"><span>回放轨迹设置</span></p>
                        <p class="setting-title car">
                            车辆选择
                            <el-button type="primary" v-popover:popover class="searchCar">选择车辆</el-button>
                        </p>

                        <div class="car-info">
                            <p class="car-title">当前车辆</p>
                            <div class="car-ico"></div>
                            <p class="info">
                            电池编码: <span>{{ currentCar.battery_code }}</span><br />
                            车牌号码: <span>{{ currentCar.plate_number }}</span><br />
                            厂家车辆编号: <span>{{ currentCar.production_vehicle_no }}</span><br />
                            </p>
                        </div>
                        <p class="setting-title time">时间选择</p>
                        <v-datepicker v-on:change="selectTimeChange" :initTime="initTime"></v-datepicker>
                        <p class="setting-title speed">播放速度</p>
                        <el-slider
                            v-model="speed"
                            :step="10"
                            class="speed-slider"
                            show-stops>
                        </el-slider>
                        <p class="setting-title progress">播放进度</p>
                        <div class="progress-contrl">
                            <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage" status="success"></el-progress>
                            <div class="svg-bt" :class="{ start: startActive, pause: pauseActive }" @click="actionchange('start')">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                     <path class="cls-1" d="M15,0A14.88,14.88,0,0,0,0,14.91a15,15,0,1,0,30,0A14.88,14.88,0,0,0,15,0Zm0,27.73A12.78,12.78,0,0,1,2.23,14.88,12.62,12.62,0,0,1,15,2.23,12.62,12.62,0,0,1,27.73,14.88,12.78,12.78,0,0,1,15,27.73Z"/>
                                     <path class="cls-1" d="M19.66,14.43a.7.7,0,0,1,0,1.14L11.94,21c-.39.28-.78.09-.78-.38V9.4c0-.47.39-.66.78-.38Z"/>
                                     <path class="cls-2" d="M15,0A14.88,14.88,0,0,0,0,14.91a15,15,0,1,0,30,0A14.88,14.88,0,0,0,15,0Zm0,27.73A12.78,12.78,0,0,1,2.23,14.88,12.62,12.62,0,0,1,15,2.23,12.62,12.62,0,0,1,27.73,14.88,12.78,12.78,0,0,1,15,27.73Z"/>
                                     <rect class="cls-2" x="10.07" y="8.89" width="2.5" height="12.22" rx="1.25" ry="1.25"/>
                                     <rect class="cls-2" x="17.09" y="8.89" width="2.5" height="12.22" rx="1.25" ry="1.25"/>
                                </svg>
                            </div>
                            <div class="svg-bt stop" :class="{disabled: stopDisabled}" @click="actionchange('stop')">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                     <path class="cls-1" d="M15,0A14.88,14.88,0,0,0,0,14.91a15,15,0,1,0,30,0A14.88,14.88,0,0,0,15,0Zm0,27.73A12.78,12.78,0,0,1,2.23,14.88,12.62,12.62,0,0,1,15,2.23,12.62,12.62,0,0,1,27.73,14.88,12.78,12.78,0,0,1,15,27.73Z"/>
                                     <rect class="cls-1" x="10" y="10" width="10.01" height="10" rx="1" ry="1"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="17" v-loading="loading2" element-loading-text="拼命加载中">
                    <div class="container-panel map">
                        <v-amap :path="path" :action="action" :speed="speed" v-on:percent="setPercent"></v-amap>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
import amap from './map/amap-path.vue';
import search from '../plugins/search';
import ws from '../plugins/ws';
import datepicker from '../plugins/date-picker';
export default {
    name: 'mobile-trajectory',
    mounted () {
        if (!(localStorage.getItem('SELECTCAR') === 'null' || !localStorage.getItem('SELECTCAR'))) {
            this.selectCar = JSON.parse(localStorage.getItem('SELECTCAR'));
            this.initTime = [localStorage.getItem('STARTTIME'), localStorage.getItem('ENDTTIME')];
            this.currentCar = this.selectCar;
            this.datetimerange = this.initTime;
        }
    },
    data () {
        return {
            loading2: false,
            speed: 50,
            navgStatus: 'stop',
            path: {
                path: [],
                car: {}
            },
            action: 'stop',
            crumb: '车辆定位 / 车辆轨迹回放',
            percentage: 0,
            visible: false,
            selectCar: {},
            currentCar: {},
            serchData: {},
            sendMessage: {},
            datetimerange: [],
            initTime: []
        };
    },
    components: {
        'v-amap': amap,
        'v-search': search,
        'v-ws': ws,
        'v-datepicker': datepicker
    },
    methods: {
        initSearch () {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: {
                    battery_code: '',
                    plate_number: '',
                    production_vehicle_no: ''
                }
            };
        },
        cancelSelect () {
            this.visible = false;
        },
        getCarTrace () {
            var self = this;
            this.loading2 = true;
            this.visible = false;
            this.currentCar = this.selectCar;
            localStorage.setItem('SELECTCAR', JSON.stringify(this.currentCar));
            this.$ajax({
                method: 'get',
                url: self.Api.trace + '44?start_time=' + self.datetimerange[0] + '&end_time=' + self.datetimerange[1]
            }).then(function (res) {
                if (res.status === 200) {
                    self.initMap(res.data);
                    self.percentage = 0;
                }
            });
        },
        initMap (path) {
            this.path = {
                path: path,
                car: this.currentCar,
                datetimerange: this.datetimerange
            };
            this.navgStatus = '';
            this.action = '';
            this.navgStatus = 'stop';
            this.action = 'stop';
            this.loading2 = false;
        },
        actionchange (actStr) {
            if (this.navgStatus === 'pause' && actStr === 'start') {
                this.action = 'resume';
                this.navgStatus = actStr;
            } else if (this.navgStatus === 'start' && actStr === 'start') {
                this.action = 'pause';
                this.navgStatus = 'pause';
            } else {
                this.action = actStr;
                this.navgStatus = actStr;
            }
        },
        setPercent (percent) {
            this.percentage = percent;
        },
        searchSelectCurrent (car) {
            this.selectCar = car;
            this.getCarTrace();
        },
        createVehicleSearch (value) {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: value
            };
        },
        changeSearchData (data) {
            this.serchData = data;
        },
        selectTimeChange (time) {
            this.datetimerange = time;
            console.log(time);
            localStorage.setItem('STARTTIME', time[0]);
            localStorage.setItem('ENDTTIME', time[1]);
            this.getCarTrace();
        }
    },
    computed: {
        startActive: function () {
            return (this.navgStatus === 'stop' || this.navgStatus === 'pause' || this.navgStatus === 'init');
        },
        stopDisabled: function () {
            return (this.navgStatus === 'stop');
        },
        pauseActive: function () {
            return (this.navgStatus === 'start');
        }

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-panel{
    height: 80vh;
    border:1px solid #e0e3e7;
    background-color: #fff;
    padding: 14px;
    color:#7f8393;
    position: relative;
    box-sizing: border-box;
    min-height: 450px;
}
.map{
    padding: 5px;
}
.container{
    margin: 15px 0 0 0;
}
.title{
    color:#5182e4;
    position: relative;
    height: 20PX;
    margin: 10px 0 20px 0;
}
.title span{
    background: #fff;
    display: inline-block;
    position: absolute;
    padding: 0 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
}
.title::before{
    content: "";
    height: 1px;
    background-color: #5182e4;
    position: absolute;
    right: 10px;
    left: 10px;
    top:10px;
}
.car-ico{
    width: 75px;
    height: 75px;
    background-image: url(../../assets/img/car_ico.png);
    position: absolute;
    background-repeat: no-repeat;
    background-position: center;
    margin:10px 45px 10px 15px;
    left: 0;
    bottom: 0;
}
.car-info{
    font-size: 12px;
    background-color: #f5f5f5;
    position: relative;
}
.info{
    text-align: left;
    padding:0 0 15px 135px;
    line-height: 2;
    margin: 0;
}
.info>span{
    color:#5182e4;
    margin-left:3px;
}
.car-title{
   text-align: left;
   margin: 0;
   padding:15px 30px 5px 30px;
}
.speed-slider{
    width: 90%;
}
.el-button--primary{
    width: 100%;
    background-color: #5182e4;
    border-color: #5182e4;
    color:#fff;
    padding: 7px 15px;
    border-radius: 0;
}
.searchCar{
    position: absolute;
    right: 0px;
    top:-5px;
}
.el-button--primary:hover{
    background-color: #0066ff;
}
/* .el-button--default{
    padding: 7px 15px;
    border-radius: 0;
    width: 100px;
    border-color: #5182e4;
    color: #5182e4;
}
.el-button--default:hover{
    border-color: #0066ff;
    color: #0066ff;
} */
.el-progress{
    margin-left:88px;
}
.progress-contrl{
    position: relative;
    margin-top:25px;
}
.svg-bt{
    width: 30px;
    height: 30px;
    position: absolute;
    left: 0;
    top:-4px;
    cursor: pointer;
}
.stop{
    left: 45px;
}
.start .cls-1{
    fill:#78acff;
}
.start .cls-2{
    display: none;
}
.pause .cls-1{
    display: none;
}
.pause .cls-2{
    fill:#ea0000;
}
.stop .cls-1{
    fill:#ea0000;
}
.disabled .cls-1{
    fill:#999;
}
.disabled{
    cursor: not-allowed;
}
.pover-search{
    height: 740px;
    max-height: 95vh;
}
.bt-popover{
    margin-top:30px;
}
@media screen and (max-height: 760px) {
    .pover-search{
        overflow-y: scroll;
    }
}
</style>



// WEBPACK FOOTER //
// mobile-trajectory.vue?4ad369ae